import { useTranslation } from 'react-i18next';

export const useLanguageParams = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return lang;
};
